import { render } from "./GroupReport.vue?vue&type=template&id=b2ef39cc&scoped=true&ts=true"
import script from "./GroupReport.vue?vue&type=script&lang=ts"
export * from "./GroupReport.vue?vue&type=script&lang=ts"

import "./GroupReport.vue?vue&type=style&index=0&id=b2ef39cc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ef39cc"]])

export default __exports__